import { calcSizeForTv } from 'utils/index';

import { Icons } from 'components/Icons';

export type KeyItemProps = {
  item: string;
  symbol: string | React.ReactNode;
  value: string | null;
  columns?: number;
};

const ALPHABET = 'abcdefghijklmnopqrstuvwxyz';
const NUMBERS = '1234567890';

const createKeys = (chars: string, uppercase = false): KeyItemProps[] =>
  chars.split('').map((char) => {
    const value = uppercase ? char.toUpperCase() : char;

    return {
      item: char,
      symbol: value,
      value,
    };
  });

const SYMBOLS: { [key: string]: KeyItemProps } = {
  SPACE: {
    item: 'space',
    symbol: <Icons.Bracket width={String(calcSizeForTv(24))} height={String(calcSizeForTv(24))} />,
    value: ' ',
    columns: 2,
  },
  SHIFT: {
    item: 'shift',
    symbol: <Icons.ArrowUp width={String(calcSizeForTv(24))} height={String(calcSizeForTv(24))} />,
    value: null,
    columns: 2,
  },
  BACKSPACE: {
    item: 'backspace',
    symbol: (
      <Icons.DeleteLeft width={String(calcSizeForTv(24))} height={String(calcSizeForTv(24))} />
    ),
    value: null,
    columns: 2,
  },
  CLEAR: {
    item: 'clear',
    symbol: <Icons.Trash width={String(calcSizeForTv(24))} height={String(calcSizeForTv(24))} />,
    value: null,
    columns: 2,
  },
};

export const ALPHABETIC_KEYBOARD: KeyItemProps[] = [
  ...createKeys(ALPHABET),
  SYMBOLS.SHIFT,
  SYMBOLS.SPACE,
  SYMBOLS.BACKSPACE,
  SYMBOLS.CLEAR,
];

export const NUMERIC_KEYBOARD: KeyItemProps[] = [...createKeys(NUMBERS), SYMBOLS.BACKSPACE];

export const HORIZONTAL_NUMERIC_KEYBOARD: KeyItemProps[] = [
  ...createKeys(NUMBERS),
  {
    ...SYMBOLS.BACKSPACE,
    columns: 10,
  },
];

export const ALPHANUMERIC_KEYBOARD: KeyItemProps[] = [
  ...createKeys(ALPHABET + NUMBERS),
  SYMBOLS.SPACE,
  SYMBOLS.BACKSPACE,
  SYMBOLS.CLEAR,
];

export const getAlphabetKeyboardUppercase = (uppercase: boolean): KeyItemProps[] => [
  ...createKeys(ALPHABET, uppercase),
  { ...SYMBOLS.SPACE, columns: 2 },
  { ...SYMBOLS.SHIFT, columns: 2 },
  { ...SYMBOLS.BACKSPACE, columns: 3 },
  { ...SYMBOLS.CLEAR, columns: 3 },
];
